<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.product_name" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_name" label="产品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_stock"  label="库存">
            <template slot-scope="scope">
              <div v-if="scope.row.spec_rel.length>0">
                <div v-for="(item, index) in scope.row.spec_rel" :key="index">
                  <el-input type="number" @change="updateLogisticsStock(item,scope.row.product_id,item.spec_value_id)" size="small" placeholder="请输入库存" v-model="item.logistics_stock">
                      <template slot="prepend">{{item.spec_value}}</template>
                  </el-input>
                </div>
              </div>
              <div v-else>
                <el-input type="number" size="small" @change="updateLogisticsStock(scope.row,scope.row.product_id)" placeholder="请输入库存" v-model="scope.row.logistics_stock">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_status.text" label="状态">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.product_status.value == 10, gray: scope.row.product_status.value == 20 }">{{ scope.row.product_status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_delete" label="是否已删除">
            <template slot-scope="scope">
              <span :class="{ green: Number(scope.row.is_delete) === 0, gray: Number(scope.row.is_delete) === 10 }">{{ Number(scope.row.is_delete) === 0 ? '否' : Number(scope.row.is_delete) === 1 ? '是' : '' }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">删除</el-button>
              <el-button @click="copyClick(scope.row)" type="text" size="small" v-auth="'/product/product/copy'">一键复制</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import LogisticsApi from '@/api/logistics.js';
export default {
  components: {},
  data() {
    return {
      logistics_id:0,
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: '',
        category_id: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: []
    };
  },
  created() {
    /*获取列表*/
    this.logistics_id = this.$route.query.logistics_id;
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      Params.logistics_id =self.logistics_id;
      self.loading = true;
      LogisticsApi.productList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.catgory;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/product/product/add');
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'edit'
        }
      });
    },

    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'copy'
        }
      });
    },

    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },

    updateLogisticsStock:function(row,product_id,product_sku_id=0){
      let self = this;
      let product_stock = 0;

      product_stock = row.logistics_stock;

      LogisticsApi.updateLogisticsStock({
            product_stock:product_stock,
            product_id: product_id,
            product_sku_id:product_sku_id,
            logistics_id:self.logistics_id,
          }).then(data => {
            self.$message({
              message: '更新成功',
              type: 'success'
            });
            self.getData();
          });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/logistics/manager/part/stock.vue